module.exports = __webpack_public_path__ + "img/highlights-h5.5474cc4b.webp";